/**
 * @fileoverview Module for `src/campaigns/lib/sorters.js`.
 */

/**
 * Sorts campaigns by priority first, then title.
 *
 * @param {Object} a - Campaign A.
 * @param {Object} b - Campaign B.
 * @returns {number} Sort comparison value.
 */
function sortCampaigns(a, b) {
  if (a.isPriority !== b.isPriority) {
    return a.isPriority ? -1 : 1;
  }
  return a.title?.localeCompare(b.title);
}

// eslint-disable-next-line import/prefer-default-export
export { sortCampaigns };
